import {useUser} from '@dofleini/security';
import {useCallback, useMemo} from 'react';

import {APPROVAL_STATUS} from '@/modules/tools/contants/approvalQueue';

const {COMPLETED, DRAFT} = APPROVAL_STATUS;

export const usePermissions = (entityName, entity, path) => {
  const {hasPermission} = useUser();

  const findEntityStatus = useMemo(() => {
    if (entity?.status !== DRAFT && entity?.status !== COMPLETED) {
      return entity?.status;
    }
  }, [entity?.status]);

  const canHandleApprovalQueue = useCallback((status) => {
    const route = '/tools/approval-queues';
    const isDraft = entity?.status === status;
    const isCompleted = entity?.status === status;
    const noDraftNorCompleted = (entity?.status === status) && (entity?.status !== isDraft) && entity?.status !== isCompleted;

    return isDraft ? (route === path) && isDraft : noDraftNorCompleted ? (route === path) && !isDraft && !isCompleted : (route === path) && isCompleted;
  }, [path, entity?.status]);

  const isAdmin = useMemo(() => hasPermission('ADMIN'), [hasPermission]);
  const canRead = useMemo(() => entityName ? hasPermission(`${entityName}:READ`) : true, [entityName, hasPermission]);
  const canWrite = useMemo(() => entityName ? hasPermission(`${entityName}:WRITE`) : true, [entityName, hasPermission]);
  const canDelete = useMemo(() => entityName ? hasPermission(`${entityName}:DELETE`) : true, [entityName, hasPermission]);

  const removeApprovalEdit = useCallback((options) => {
    const optionsNoEdit = options.filter(item => (item.action !== 'edit'));
    const optionsOnlyDetail = options.filter(item => (item.action === 'details'));

    return canHandleApprovalQueue(COMPLETED) ? optionsOnlyDetail : canHandleApprovalQueue(findEntityStatus) ? optionsNoEdit : options;

  }, [findEntityStatus, canHandleApprovalQueue]);

  const optionsByPermissions = useCallback((options = [], entityName, actions, atLeastOne) => {
    const finalOptions = removeApprovalEdit(options);
    return finalOptions.filter(item => {
      const items = Array.isArray(item.permissions) ? item.permissions?.map((e) => entityName + ':' + e) : `${entityName}:${item.permissions}`;
      return hasPermission(items, atLeastOne) && (actions ? actions[item.action] : true);
    });
  }, [hasPermission, removeApprovalEdit]);

  return {
    isAdmin,
    canRead,
    canWrite,
    canDelete,
    canHandleApprovalQueue,
    haveFullAccess: canRead && canWrite && canDelete,
    optionsByPermissions
  };
};

